import {
  PlateEditor,
  PlatePlugin,
  TRenderLeafProps,
} from '@udecode/plate-core';
import styled from 'styled-components';

export const HIDE_MARK = 'hide';
export const createHidePlugin = (): PlatePlugin => {
  return {
    //@ts-ignore for now
    pluginKeys: [HIDE_MARK],
    renderLeaf: getHideComponent,
  };
};

const getHideComponent = (editor: PlateEditor) => {
  return (props: TRenderLeafProps<{ [HIDE_MARK]: boolean }>) => {
    if (!props.leaf[HIDE_MARK] === true) {
      return undefined;
    }
    return (
      <Hide data-hello-world="hello world" {...props.attributes}>
        {props.children}
      </Hide>
    );
  };
};

const Hide = styled.span`
  background-color: ${(props) => props.theme.colors.main.medium};
  color: ${(props) => props.theme.colors.main.medium};

  :hover {
    color: inherit;
  }
`;
